import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { Form, Button, Alert, Card, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const WorkedDocs = () => {
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUsername, setSelectedUsername] = useState('');
    const [files, setFiles] = useState([]);
    const [users, setUsers] = useState([]); // Store the fetched users
    const [error, setError] = useState(''); // Error state
    const [successMessage, setSuccessMessage] = useState(null); // Success message state
    const [isSubmitting, setIsSubmitting] = useState(false); // State to handle submission status
    const navigate = useNavigate();
    
   
    // Handle file change
    const handleFileChange = (e) => {
        setFiles(e.target.files);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch user data
                const userResponse = await fetch('https://apiaksharaconnect.aksharafinalytics.in/Ausers');

                if (!userResponse.ok) {
                    throw new Error('Failed to fetch users');
                }

                const userResult = await userResponse.json();
                setUsers(userResult.user || []); // Set the fetched users

            } catch (error) {
                setError(error.message); // Set error message
            }
        };

        fetchData();
    }, []);

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!selectedUserId || !selectedUsername || files.length === 0) {
            setError('User ID, Username, and Files are required.');
            return;
        }
    
        setIsSubmitting(true); 
        const remarks = document.getElementById('remarks').value; 
        const empId = localStorage.getItem('userId');
        const formData = new FormData();
        formData.append('user_id', selectedUserId); 
        formData.append('username', selectedUsername); 
        formData.append('remarks', remarks);
        formData.append('emp_id', empId);     

        
        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i]);
        }        
    
        try {
            const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/Files', {
                method: 'POST',
                body: formData,
            });
    
            const res = await response.json();
            console.log(res);
    
            if (res.status === 'success') {
                setSuccessMessage(res.message);    
                setTimeout(() => {
                    window.location.reload(); 
                }, 3000); 
            } else {
                setError(res.message);
            }
        } catch (error) {
            setError(error.message); // Set error message on failed submission
        } finally {
            setIsSubmitting(false); // Stop submitting
        }
    };
    

    // Update selectedUserId and selectedUsername when a user is selected from the dropdown
    const handleUserSelection = (e) => {
        const selectedUser = users.find(user => user.id === e.target.value);
        if (selectedUser) {
            setSelectedUserId(selectedUser.id);
            setSelectedUsername(selectedUser.name);
        }
    };

    return (
        <>
            <Header />

            <Container className="mt-5">
                <Card className="shadow">
                    <Card.Header>
                        <h3>
                            Worked Docs Form &nbsp;
                            <button className="btn btn-primary" onClick={() => navigate('/DisWorkedDoc')}>
                                View Worked Docs
                            </button>
                        </h3>
                    </Card.Header>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {successMessage && <Alert variant="success">{successMessage}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Select User</Form.Label>
                                <Form.Control as="select" value={selectedUserId} onChange={handleUserSelection} required >
                                    <option value="">Select User</option>
                                    {users.map((user) => (
                                        <option key={user.id} value={user.id}>
                                            {user.company}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Select Files: (select multi files to upload)</Form.Label>
                                <Form.Control type="file" id="files" onChange={handleFileChange} multiple required />
                                <small className='text-danger'>only uploads file ( pdf, xlsx, csv, jpg, png )</small>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Remarks</Form.Label>
                                <Form.Control as="textarea" id="remarks" name="remarks" rows={3} placeholder="Enter any Remarks" />
                            </Form.Group>

                            <Row className="justify-content-center">
                                <Col xs="auto">
                                <Button type="submit" variant="primary" disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Submit'}</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default WorkedDocs;
